import React from 'react';
import { X, Mail, Loader2 } from 'lucide-react';

const EmailConfirmModal = ({ 
    emailRecipient, 
    setEmailRecipient, 
    ccRecipients, 
    setCcRecipients, 
    isSendingEmail, 
    onClose, 
    onConfirm 
}) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl transform transition-all text-[10.5px]" style={{ fontSize: '10.5px' }}>
                <div className="p-6">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                        <h3 className="text-gray-900 text-[10.5px] font-semibold" style={{ fontSize: '10.5px' }}>
                            Send Interview Feedback
                        </h3>
                        <button
                            onClick={onClose}
                            className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            <X size={16} className="text-gray-500" />
                        </button>
                    </div>

                    {/* Form */}
                    <div className="bg-gray-50 rounded-xl p-6 mb-6 space-y-4 text-[10.5px]" style={{ fontSize: '10.5px' }}>
                        <div>
                            <label className="block text-gray-700 mb-1.5 text-[10.5px] font-medium" style={{ fontSize: '10.5px' }}>
                                Recipient Name
                            </label>
                            <div className="text-gray-900 text-[10.5px] font-medium" style={{ fontSize: '10.5px' }}>
                                {emailRecipient?.name}
                            </div>
                        </div>
                        
                        <div>
                            <label className="block text-gray-700 mb-1.5 text-[10.5px] font-medium" style={{ fontSize: '10.5px' }}>
                                Email Address
                            </label>
                            <input
                                type="email"
                                value={emailRecipient?.email || ''}
                                onChange={(e) => setEmailRecipient(prev => ({ 
                                    ...prev, 
                                    email: e.target.value 
                                }))}
                                placeholder="Enter recipient email address"
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors text-[10.5px]"
                                style={{ fontSize: '10.5px' }}
                            />
                        </div>
                        
                        <div>
                            <label className="block text-gray-700 mb-1.5 text-[10.5px] font-medium" style={{ fontSize: '10.5px' }}>
                                CC Recipients
                            </label>
                            <input
                                type="text"
                                value={ccRecipients}
                                onChange={(e) => setCcRecipients(e.target.value)}
                                placeholder="Enter email addresses (comma-separated)"
                                className="w-full px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors text-[10.5px]"
                                style={{ fontSize: '10.5px' }}
                            />
                            <p className="text-gray-500 mt-1 text-[10.5px]" style={{ fontSize: '10.5px' }}>
                                Separate multiple email addresses with commas
                            </p>
                        </div>
                    </div>

                    {/* Email Contents Info */}
                    <div className="bg-blue-50 rounded-xl p-4 mb-6 border border-blue-200 text-[10.5px]" style={{ fontSize: '10.5px' }}>
                        <div className="flex items-center gap-2 mb-3">
                            <Mail size={14} className="text-blue-600" />
                            <span className="text-blue-900 font-medium text-[10.5px]" style={{ fontSize: '10.5px' }}>Email will include:</span>
                        </div>
                        <ul className="text-blue-800 space-y-1 ml-6 text-[10.5px]" style={{ fontSize: '10.5px' }}>
                            <li className="list-disc">Interview feedback summary</li>
                            <li className="list-disc">Overall score and category scores</li>
                            <li className="list-disc">Question & answer pairs with scores</li>
                            {emailRecipient?.htmlContent ? (
                                <li className="list-disc text-green-700">
                                    ✓ PDF report attachment
                                </li>
                            ) : (
                                <li className="list-disc text-amber-700">
                                    ⚠ PDF report (generation failed)
                                </li>
                            )}
                        </ul>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-[10.5px]"
                            style={{ fontSize: '10.5px' }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isSendingEmail}
                            className="flex-1 px-4 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2 text-[10.5px] font-medium"
                            style={{ fontSize: '10.5px' }}
                        >
                            {isSendingEmail ? (
                                <>
                                    <Loader2 size={14} className="animate-spin" />
                                    Sending...
                                </>
                            ) : (
                                <>
                                    <Mail size={14} />
                                    Send Email
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailConfirmModal;